export default "__VITE_ASSET__Bg68bXNn__"